<template>
  <div class = "st-table">
    <el-row :gutter="16" type="flex" justify=start>
        <el-card shadow="always" style="width: 100%">
          <el-form :model="query" label-width="80px">
                <el-col :span="8">
                  <el-form-item label="Date" :span="8">
                    <el-date-picker
                      v-model="query.operationDate"
                      type="daterange"
                      align="right"
                      range-separator="to"
                      :editable="false"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-button type="primary" class="btn" @click="search">
                    Search
                  </el-button>
                </el-form-item>
              </el-col>
          </el-form>
        </el-card>
    </el-row>
    <br/>

    <el-row :gutter="16">
      <el-card title="Leave Status" shadow="always" style="width: 100%">
        <el-form>
          <el-table
            :data="attStatus" border style="width: 100%" class="el-table">
            <el-table-column
              prop="user"
              label="Name"
            >
            </el-table-column>
            <el-table-column
              prop="pto"
              label="Time Off Request – PTO (Hrs)"
            >
            </el-table-column>
            <el-table-column
              prop="upto"
              label="Time Off Request – UPTO (Hrs)"
            >
            </el-table-column>
            <el-table-column
              prop="jd"
              label="Jury Duty (Hrs)"
            >
            </el-table-column>
            <el-table-column
              prop="bereavement"
              label="BEREAVEMENT (Hrs)"
            >
            </el-table-column>
          </el-table>

        </el-form>
      </el-card>
    </el-row>


  </div>
</template>

<script>
import attendanceApi from '@/api/attendance.js';

export default {
  name: "attStatus",

  data() {
    return {
      query: {
        operationDate: '',
      },
      loading: false,
      attStatus: [],
    }
  },
  methods: {
    handleReset() {
      this.query.operationDate = ''
    },
    search() {
      let para = {}
      para['date_from'] = this.query.operationDate[0]
      para['date_to'] = this.query.operationDate[1]
      this.loading = true
      attendanceApi.getAttStatus(para).then(res => {
        this.attStatus = res.data.data
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" >
.el-table th.el-table__cell {
  user-select: initial;
}

</style>

